import React from "react";
import SEOHead from "../components/SEOHead";
import logo from "../assets/logo.png"

const ComingSoonPage = () => {
  return (
    <>
      <SEOHead page="coming-soon" />

      <div className="min-h-screen bg-[#05070d] flex items-center justify-center relative overflow-hidden">

        {/* Background grid pattern */}
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                "radial-gradient(circle at 2px 2px, white 1px, transparent 0)",
              backgroundSize: "40px 40px",
            }}
          />
        </div>

        {/* Blue glow background */}
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-blue-400/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] bg-blue-300/10 rounded-full blur-3xl"></div>

        <div className="relative text-center px-6">

          {/* Logo */}
          <img
            // src={logo}
            src="http://agency.hubst3r.com/wp-content/uploads/2026/03/FD577C02-E849-4FE8-AAAA-0F360C9A8591.png"
            alt="RAL Real Advisor"
            className="w-[320px] mx-auto mb-10"
          />

          {/* Coming soon */}
          <p className="text-sm tracking-[0.35em] uppercase text-blue-200 mb-4">
            Coming Soon
          </p>

          <h1 className="text-5xl lg:text-6xl font-serif font-bold text-white leading-tight mb-6">
            Something
            <br />
            <span className="text-[#9fc6ff]">Is Coming</span>
          </h1>

          <p className="text-neutral-400 max-w-xl mx-auto">
            We’re preparing a new experience. Stay tuned.
          </p>
        </div>
      </div>
    </>
  );
};

export default ComingSoonPage;